




























































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import Decimal from "@/components/inputs/Decimal.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";
import Editor from '@tinymce/tinymce-vue';
import {ActionsEnum} from "@/entity/ActionsEnum";
class Kurulum{
  id!:number;
  title!:string;
  name!:string;
  no!:number;
  enabled!:number;
  pdf_url!:string;
  file!:File;
}
@Component({
  components: {
    ImageUpload,
    Decimal,
    EnabledSwitch,
    DeleteButton,EForm,Number,TextField,Id,Editor
  }
})

export default class Kurulumlar extends  Vue{
  items : Kurulum[] | null = null;
  dialog = false;
  title:string = "";
  search: string = "";
  baseAction:string = ActionsEnum.Kurulum;
  action:string = this.baseAction;
  data : Kurulum = new Kurulum();
  headers = [
    {
      text: "Id",
      align: "start",
      sortable: true,
      value: "id"
    },
    {text: "URL", value: "name"},
    {text: "Başlık", value: "title"},
    {text: "Sıra", value: "no"},
    {text: "Aktif", value: "enabled"},
    {text: "İşlemler", value: "actions"}
  ];
  edit(item:Kurulum){
    this.title = "Düzenle";
    this.data = item;
    this.action = this.baseAction + "/" + item.id;
    this.dialog = true;
  }
  add(){
    this.title = "Ekle";
    this.action = this.baseAction;
    this.data = new Kurulum();
    this.dialog = true;
  }
  async get(){
    this.dialog = false;
    let response = await this.$http.get(this.baseAction);
    this.items = response.data;
  }
  created(){
    this.get();
  }
};
